import { useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import HeaderBar from "../../../../Components/UI/headerbar";
import LoadingSpinner from "../../../../Components/UI/spinner";
import ActionsCard from "../../../../Components/product/show/actionscard";
import AddsOneProduct from "../../../../Components/product/show/addsproduct";
import NutritionCard from "../../../../Components/product/show/nutritionCard";
import OfferCard from "../../../../Components/product/show/offercard";
import OptionValuesCard from "../../../../Components/product/show/optionvalues";
import ProductMainCard from "../../../../Components/product/show/productMainCard";
import StatsProductCard from "../../../../Components/product/show/statscard";
import StoreInfoCard from "../../../../Components/product/show/storeInfoCard";
import { showProducts } from "../../../../MyApi/product";
import ProductReviews from "../../../../Components/product/show/productReviews";
import { ArrowLeft, ArrowRight } from "react-feather";

const ProductShowPage = () => {
  const { id } = useParams();
  const { data, isLoading ,error ,refetch} = useQuery(["showproduct",id], () => showProducts(id));
  const product = data?.data?.product || {};
  const location = useLocation();
  const page = location.state?.page || 1;
 const navigate = useNavigate();
  if (isLoading) {
    return <LoadingSpinner />;
  }
  if(error){
    return <div>error</div>
  }
  console.log('page', page)
  return (
    <div className="row product-show">
      <HeaderBar
        title={"تفاصيل المنتج"}
        content={"عرض المنتجات داخل المتجر."}
        isBack={true}
        indexPath={`/products?page=${page}`}
        page={page}
      />
  
   
      <div className="col-md-8">
        <ProductMainCard product={product} id={id} />
        <AddsOneProduct adds={product.add_ons} currency_factor={product.currency_factor} />
        <OptionValuesCard options={product.product_options} />
        <ProductReviews productId={id}/>
      </div>
      <div className="col-md-4">
        <ActionsCard id={id} refetch={refetch} />
        <StoreInfoCard product={product} />
        <StatsProductCard id={id} />

        <NutritionCard {...product.productNutrition} />
        <OfferCard offer={product.nearest_offer} product={product} />
      </div>
    </div>
  );
};

export default ProductShowPage;
